/**
 * Config: Breakpoints
 * -----------------------------------------------------------------------------
 * Global configuration for consistent values for media queries in scripts.
 * - Automatically generated by `design` command, do not edit.
 *
 */
// eslint-disable

export const values = {
  'xs': 0,
  's': 576,
  'm': 768,
  'l': 1024,
  'xl': 1440,
  '2xl': 1920,
}

export default {
  'xs': `${values.xs}px`,
  's': `${values.s}px`,
  'm': `${values.m}px`,
  'l': `${values.l}px`,
  'xl': `${values.xl}px`,
  '2xl': `${values['2xl']}px`,
}
